//
// Copyright (c) 2025 by Curalate, Inc.
//

export const FeatureNames = {
  AiContentDiscovery: 'ai_content_discovery',
  AllowPublishing404Urls: 'allow_publishing_404_urls',
  ArbitraryLinkTracking: 'arbitrary_link_tracking',
  AssetFeedTagging: 'asset_feed_tagging',
  AssistedProductTagging: 'assisted_product_tagging',
  AutomatedReporting: 'automated_reporting',
  AutomatedReportingRefresh: 'automated_reporting_refresh',
  AutomatedReportingRefreshUi: 'automated_reporting_refresh_ui',
  AutomatedTaggedByBazaarvoice: 'automated_tagged_by_bazaarvoice',
  BazaarvoiceNetworkSyndication: 'bazaarvoice_network_syndication',
  BazaarvoiceNetworkSyndicationBlockVendorRights: 'bazaarvoice_network_syndication_block_vendor_rights',
  BazaarvoiceNetworkSyndicationFrontend: 'bazaarvoice_network_syndication_frontend',
  BazaarvoiceNetworkSyndicationOnlyFullClient: 'bazaarvoice_network_syndication_only_full_client',
  BazaarvoiceNetworkSyndicationPublisher: 'bazaarvoice_network_syndication_publisher',
  BazaarvoiceNetworkSyndicationUgc: 'bazaarvoice_network_syndication_ugc',
  BazaarvoiceReviewContent: 'bazaarvoice_review_content',
  BazaarvoiceSamplingContentToModeration: 'bazaarvoice_sampling_content_to_moderation',
  BeautifyUseTranscodedImage: 'beautify_use_transcoded_image',
  BvPortalQuickLink: 'bv_portal_quick_link',
  BvUserManagement: 'bv_user_management',
  CaasAutoApproveBrandContent: 'caas_auto_approve_brand_content',
  CanvaIntegration: 'canva_integration',
  Captions: 'captions',
  ChromeExtensionMis: 'chrome_extension_mis',
  ConnectStream: 'connect_stream',
  ContentCollectionsPermissions: 'content_collections_permissions',
  ContentCollectionsSearch: 'content_collections_search',
  ContentDiscovery: 'content_discovery',
  ContentDrawerMediaRecommendations: 'content_drawer_media_recommendations',
  ContentDrawerRefresh: 'content_drawer_refresh',
  ContentLibraryCampaignImprovements: 'content_library_campaign_improvements',
  ContentLibraryDistributionImprovements: 'content_library_distribution_improvements',
  ContentLibraryEndpointMigration: 'content_library_endpoint_migration',
  ContentLibraryFiltersImprovements: 'content_library_filters_improvements',
  ContentLibraryGatewayEnabled: 'content_library_gateway_enabled',
  ContentLibraryLabelsImprovements: 'content_library_labels_improvements',
  ContentLibraryMenuImprovements: 'content_library_menu_improvements',
  ContentLibraryProductsImprovements: 'content_library_products_improvements',
  ContentLibraryUsernameHashtagImprovements: 'content_library_username_hashtag_improvements',
  ContentSource: 'content_source',
  ContextualPdpFanreel: 'contextual_pdp_fanreel',
  CreatorBrandSafety: 'creator_brand_safety',
  CreatorCampaignAffiliates: 'creator_campaign_affiliates',
  CreatorCampaignConfigurationBvRights: 'creator_campaign_configuration_bv_rights',
  CreatorCampaigns: 'creator_campaigns',
  CreatorCampaignsContentApproval: 'creator_campaigns_content_approval',
  CreatorCampaignsSelfManagedLimit: 'creator_campaigns_self_managed_limit',
  CreatorCampaignsSentiments: 'creator_campaigns_sentiments',
  CreatorCommunity: 'creator_community',
  CreatorManagedServices: 'creator_managed_services',
  CustomReporting: 'custom_reporting',
  DamImportDropbox: 'dam_import_dropbox',
  DisableInsightsRefreshOptOut: 'disable_insights_refresh_opt_out',
  DraftEmailTemplate: 'draft_email_template',
  EcommerceFanreelIntegration: 'ecommerce_fanreel_integration',
  EcommerceIntegrationsMagento: 'ecommerce_integrations_magento',
  EcommerceIntegrationsShopify: 'ecommerce_integrations_shopify',
  EmailBuilder: 'email_builder',
  EnableDualWriteSocialMiningService: 'enable_dual_write_mining_service_v2',
  Engage: 'engage',
  ExperiencesGatewayService: 'experiences_gateway_service',
  FacebookAdsCuralateLookalikeAudience: 'facebook_ads_curalate_lookalike_audience',
  FacebookGraphApiMentionsIngestion: 'facebook_graph_api_mentions_ingestion',
  FacebookPageMetrics: 'facebook_page_metrics',
  Fanreel: 'fanreel',
  FanreelLike2buyAsDatasource: 'fanreel_like2buy_as_datasource',
  FanreelManagement: 'fanreel_management',
  FanreelSelfServeCustomization: 'fanreel_self_serve_customization',
  FanreelSelfServeModalV2: 'fanreel_self_serve_modal_v2',
  FanreelShowScheduledUgc: 'fanreel_show_scheduled_ugc',
  FanreelUseContentLibraryQueries: 'fanreel_use_content_library_queries',
  FeedEngagementLabelFiltering: 'feed_engagement_label_filtering',
  FreshdeskIntegration: 'freshdesk_integration',
  Galleries: 'galleries',
  GalleriesBrandAutoApproval: 'galleries_brand_auto_approval',
  GalleriesBulkApprovalDeselectAll: 'galleries_bulk_approval_deselect_all',
  GalleriesClientMigratedFromFanreel: 'galleries_client_migrated_from_fanreel',
  GalleriesCustom: 'galleries_custom',
  GalleriesCustomIsLegacyOrApiClient: 'galleries_custom_is_legacy_or_api_client',
  GalleriesInsightsBenchmarks: 'galleries_insights_benchmarks',
  GalleriesInsightsContentCoverage: 'galleries_insights_content_coverage',
  GalleriesInsightsOnsiteTraffic: 'galleries_insights_onsite_traffic',
  GalleriesMediaUploader: 'galleries_media_uploader',
  GalleriesNoGalleriesSelected: 'galleries_no_galleries_selected',
  GalleriesPinnedMedia: 'galleries_pinned_media',
  GalleriesRightsConfigurationModal: 'galleries_rights_configuration_modal',
  GalleriesSelfServeLocalization: 'galleries_self_serve_localization',
  GalleriesStreamsExclusions: 'galleries_streams_exclusions',
  GalleriesVideoCommerceLayout: 'galleries_video_commerce_layout',
  GenerativeRightsRequest: 'generative_rights_request',
  GoogleAnalytics4: 'google_analytics_4',
  HarmonyAiCreatorsCount: 'harmony_ai_creators_count',
  HarmonyAiCreatorsIntegration: 'harmony_ai_creators_integration',
  HashtagGraphApiDemo: 'hashtag_graph_api_demo',
  HashtagTrackingAndInsights: 'hashtag_tracking_and_insights',
  ImageInsights: 'image_insights',
  ImageInsightsInternal: 'image_insights_internal',
  ImageLibraryToggle: 'image_library_toggle',
  IndexBatchPosting: 'index_batch_posting',
  InfluencersDiscovery: 'influencers_discovery',
  InfluencersLimitManagement: 'influencers_limit_management',
  InfluencersManagementV2: 'influencers_management_v2',
  InfluencersNonBusiness: 'influencers_non_business',
  InfluencersRights: 'influencers_rights',
  InfluensterCampaigns: 'influenster_campaigns',
  InfluensterProStatus: 'influenster_pro_status',
  InsightsAttributionModelPicker: 'insights_attribution_model_picker',
  InsightsClientPerformanceReport: 'insights_client_performance_report',
  InsightsCustomGalleriesBreakdownImprovements: 'insights_custom_galleries_breakdown_improvements',
  InsightsRefresh: 'insights_refresh',
  InstagramAccountBasic: 'instagram_account_basic',
  InstagramAdsContentAllowlisting: 'instagram_ads_content_allowlisting',
  InstagramCompetitors: 'instagram_competitors',
  InstagramCompetitorsOldDeprecate: 'instagram_competitors_old_deprecate',
  InstagramCoverUpload: 'instagram_cover_upload',
  InstagramDraftPosts: 'instagram_draft_posts',
  InstagramDraftPostsWeb: 'instagram_draft_posts_web',
  InstagramEngagementCsvDirectDownload: 'instagram_engagement_csv_direct_download',
  InstagramGraphApiHashtags: 'instagram_graph_api_hashtags',
  InstagramIgtvScheduling: 'instagram_igtv_scheduling',
  InstagramLike2buyV2: 'instagram_like2buy_v2',
  InstagramMentionsWebhookMediaQueries: 'instagram_mentions_webhook_media_queries',
  InstagramPageDeprecation: 'instagram_page_deprecation',
  InstagramScheduler: 'instagram_scheduler',
  InstagramSchedulerSkipValidation: 'instagram_scheduler_skip_validation',
  InstagramSchedulerUncompressManualPosts: 'instagram_scheduler_uncompress_manual_posts',
  InstagramShopTagsInsights: 'instagram_shop_tags_insights',
  InstagramShopsUgc: 'instagram_shops_ugc',
  InstagramStoriesFanreelIngestion: 'instagram_stories_fanreel_ingestion',
  InstagramSummaryV2: 'instagram_summary_v2',
  InstagramViewsMigration: 'instagram_views_migration',
  Instashop: 'instashop',
  IpssNssDualWrite: 'ipss_nss_dual_write',
  LabelManagement: 'label_management',
  LargeVideoUpload: 'large_video_upload',
  Like2Buy: 'like2buy',
  Like2BuyCustomizations: 'like2buy_customizations',
  Like2BuyCustomizationsInstagram: 'like2buy_customizations_instagram',
  Like2BuyCustomizationsTiktok: 'like2buy_customizations_tiktok',
  Like2BuyDirectUpload: 'like2buy_direct_upload',
  Like2BuyPersonalCarousel: 'like2buy_personal_carousel',
  Like2BuyPinning: 'like2buy_pinning',
  Like2BuyPinningInstagram: 'like2buy_pinning_instagram',
  Like2BuyPinningTiktok: 'like2buy_pinning_tiktok',
  Like2BuyTiktok: 'like2buy_tiktok',
  LocalizeProductsLike2buy: 'localize_products_like2buy',
  LocalizeProductsReveal: 'localize_products_reveal',
  MagentoCapabilitiesEnabled: 'magento_capabilities_enabled',
  MeasureInstagram: 'measure_instagram',
  MediaLibraryPage: 'media_library_page',
  MediaLibraryReact: 'media_library_react',
  MediaLibraryTiktokFilter: 'media_library_tiktok_filter',
  MentionedAndTaggedRecommendedSorting: 'mentioned_and_tagged_recommended_sorting',
  MobileVideoUpload: 'mobile_video_upload',
  MostOnBrand: 'most_on_brand',
  MultiHandleHashtagTracking: 'multi_handle_hashtag_tracking',
  MultiHandleInstagram: 'multi_handle_instagram',
  NationalTreasureProductsBulkUpload: 'national_treasure_products_bulk_upload',
  NonAtMentionedRightsRequestsDisplayApi: 'non_at_mentioned_rights_requests_display_api',
  Notes: 'notes',
  NotificationsDeprecation: 'notifications_deprecation',
  NotificationsUiDeprecation: 'notifications_ui_deprecation',
  OnePageSelfServe: 'one_page_self_serve',
  PdpContentCoverageFollowups: 'pdp_content_coverage_followups',
  PermalinkSupport: 'permalink_support',
  Pinterest: 'pinterest',
  PinterestAds: 'pinterest_ads',
  PinterestClickData: 'pinterest_click_data',
  PinterestSchedulingRefresh: 'pinterest_scheduling_refresh',
  ProductFeedHealth: 'product_feed_health',
  PromotedPosts: 'promoted_posts',
  Publish: 'publish',
  ReplatformMigration: 'replatform_migration',
  RevealPage: 'reveal_page',
  RevealV2: 'reveal_v2',
  RightsInsights: 'rights_insights',
  RightsManagementPage: 'rights_management_page',
  RightsRequestsIncludeUsername: 'rights_requests_include_username',
  RightsRequestsQueue: 'rights_requests_queue',
  RightsRequestsStripHttp: 'rights_requests_strip_http',
  RightsRequestsTermsAndConditions: 'rights_requests_terms_and_conditions',
  RightsRequestsThirdParty: 'rights_requests_third_party',
  RightsRequestsTwitter: 'rights_requests_twitter',
  RightsRequestsViaDm: 'rights_request_via_dm',
  SamplingCampaignsCertiniaTasks: 'sampling_campaigns_certinia_tasks',
  SchedulerCalendarRecommendedTimesToPost: 'scheduler_calendar_recommended_times_to_post',
  SchedulerCrossPlatformPosting: 'scheduler_cross_platform_posting',
  SchedulerDrafts: 'scheduler_drafts',
  SchedulerFeedPreview: 'scheduler_feed_preview',
  SchedulerForecaster: 'scheduler_forecaster',
  SchedulerGenAiCaption: 'scheduler_gen_ai_caption',
  SchedulerPostTimeRecommendationsInstagram: 'scheduler_post_time_recommendations_instagram',
  SchedulerPostTimeRecommendationsTiktok: 'scheduler_post_time_recommendations_tiktok',
  SearchFiltersRedux: 'search_filters_redux',
  SettingsRefresh: 'settings_refresh',
  ShareEmailInvite: 'share_email_invite',
  ShareV2: 'share_v2',
  ShopifyOnboarding: 'shopify_onboarding',
  ShopifyOrderCreation: 'shopify_order_creation',
  ShowroomAnalyticsLiftStats: 'showroom_analytics_lift_stats',
  ShowroomAnalyticsV11: 'showroom_analytics_v1_1',
  ShowroomAutomatedReporting: 'showroom_automated_reporting',
  ShowroomDesktopExperience: 'showroom_desktop_experience',
  ShowroomGallery: 'showroom_gallery',
  ShowroomGalleryPerPostTracking: 'showroom_gallery_per_post_tracking',
  ShowroomPerPostTracking: 'showroom_per_post_tracking',
  ShowroomSelfServeV2: 'showroom_self_serve_v2',
  SimilarityToActedOn: 'similarity_to_acted_on',
  SimilarityToApproved: 'similarity_to_approved',
  Social: 'social',
  SocialAnalyticsFollowersOnlineInstagram: 'social_analytics_followers_online_instagram',
  SocialAnalyticsFollowersOnlineTiktok: 'social_analytics_followers_online_tiktok',
  SocialDashboards: 'social_dashboards',
  SocialListening: 'social_listening',
  SocialListeningCompetitor: 'social_listening_competitor',
  SocialResponse: 'social_response',
  SocialResponseAiResponse: 'social_response_ai_response',
  SocialResponseInstagramDm: 'social_response_instagram_dm',
  SocialResponseInstagramDmMining: 'social_response_instagram_dm_mining',
  SocialResponseMining: 'social_response_mining',
  SocialResponseMultiHandle: 'social_response_multi_handle',
  SocialResponseRequestReviews: 'social_response_request_reviews',
  SocialResponseTemplates: 'social_response_templates',
  SocialResponseTiktok: 'social_response_tiktok',
  SocialResponseTiktokMining: 'social_response_tiktok_mining',
  SocialResponseUgc: 'social_response_ugc',
  SocialResponseUgcMining: 'social_response_ugc_mining',
  SpamFanreelModeration: 'spam_fanreel_moderation',
  Syndication: 'syndication',
  TaggedByCuralate: 'tagged_by_curalate',
  TaggingServices: 'tagging_services',
  TeamManagementFull: 'team_management_full',
  TiktokAdViews: 'tiktok_ad_views',
  TiktokSparkAds: 'tiktok_spark_ads',
  TiltModeration: 'tilt_moderation',
  TrackedSourceManagement: 'tracked_source_management',
  TrackingEmbedUrlFragment: 'tracking_embed_url_fragment',
  TributarySelfServe: 'tributary_self_serve',
  TwoFactorAuthCustomers: 'two_factor_auth_customers',
  TwoFactorAuthEmployees: 'two_factor_auth_employees',
  UiGoogleAnalytics4: 'ui_google_analytics_4',
  UiaIntelligentProductTagging: 'uia_intelligent_product_tagging',
  UiaPermalinks: 'uia_permalinks',
  UiaPreferredCaptionEditing: 'uia_preferred_caption_editing',
  UiaReactPortItemDetails: 'uia_react_port_item_details',
  UiaReactPortItemLabels: 'uia_react_port_item_labels',
  UiaReactPortItemProducts: 'uia_react_port_item_products',
  UiaReactPortItemRights: 'uia_react_port_item_rights',
  UiaVideoClosedCaptions: 'uia_video_closed_captions',
  UiaVideoMute: 'uia_video_mute',
  UnifiedFbGraphApiOauth: 'unified_fb_graph_api_oauth',
  UniversalImageActions: 'universal_image_actions',
  UniversalScheduler: 'universal_scheduler',
  UnlimitedCreatorTracking: 'unlimited_creator_tracking',
  UrlTrackingParams: 'url_tracking_params',
  UrlTrackingParamsV2: 'url_tracking_params_v2',
  UserUploadDetails: 'user_upload_details',
  VibePayments: 'vibe_payments',
  VisualRefresh2020: 'visual_refresh_2020',
  WalkthroughsAlwaysComplete: 'walkthroughs_always_complete',
  WebappIpssDualReads: 'webapp_ipss_dual_reads',
  WhiteLabelGalleriesBranding: 'white_label_galleries_branding',
  XmpMetadataTagging: 'xmp_metadata_tagging',
  YoutubeAnalytics: 'youtube_analytics',
  YoutubeAutomaticPosting: 'youtube_automatic_posting',
  YoutubeCreatorTracking: 'youtube_creator_tracking',
} as const;

type Values<T> = T[keyof T];
export type FeatureNames = Values<typeof FeatureNames>;
